import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { $api } from '../../../../helpers/api'
import axios from 'axios'

export const createVolume = createAsyncThunk('create volume', async volumeData => {
  try {
    const result = await $api.post(`/volumes`, volumeData)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

export const getVolumes = createAsyncThunk('get volumes data', async () => {
  try {
    const result = await $api.get(`/volumes`)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

export const getVolumeById = createAsyncThunk('get volume by id', async volumeId => {
  try {
    const result = await $api.get(`/volumes/${volumeId}`)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

export const updateVolume = createAsyncThunk('update volume', async ({ volumeId, volumeData }) => {
  try {
    const result = await $api.put(`/volumes/${volumeId}`, volumeData)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      console.error(e.message)
    }
  }
})

export const deleteVolume = createAsyncThunk(
  'delete volume',
  async ({ volumeId }, { rejectWithValue }) => {
    try {
      const result = await $api.delete(`/volumes/${volumeId}`)
      return result.data
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return rejectWithValue(e.message)
      }
    }
  }
)

export const createIssue = createAsyncThunk(
  'create issue',
  async ({ volumeId, issueData }, { rejectWithValue }) => {
    try {
      const result = await $api.post(`/volumes/issue/${volumeId}`, issueData)
      return result.data
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return rejectWithValue(e.message)
      }
    }
  }
)

export const getIssueById = createAsyncThunk('get issue by id', async issueId => {
  try {
    const result = await $api.get(`/volumes/issue/${issueId}`)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

export const updateIssue = createAsyncThunk(
  'update issue',
  async ({ issueId, issueData }, { rejectWithValue }) => {
    try {
      const result = await $api.put(`/volumes/issue/${issueId}`, issueData)
      return result.data
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return rejectWithValue(e.message)
      }
    }
  }
)

export const deleteIssue = createAsyncThunk('delete issue', async issueId => {
  try {
    const result = await $api.delete(`/volumes/issue/${issueId}`)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

export const createArticle = createAsyncThunk(
  'create article',
  async ({ issueId, articleData }) => {
    try {
      const result = await $api.post(`/volumes/article/${issueId}`, articleData)
      return result.data
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return console.error(e.message)
      }
    }
  }
)

export const getArticleById = createAsyncThunk('get article by id', async articleId => {
  try {
    const result = await $api.get(`/volumes/article/${articleId}`)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

export const updateArticle = createAsyncThunk(
  'update article',
  async ({ issueId, articleId, articleData }) => {
    try {
      const result = await $api.put(`/volumes/article/${articleId}`, articleData)
      return result.data
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return console.error(e.message)
      }
    }
  }
)

export const deleteArticle = createAsyncThunk('delete article', async articleId => {
  try {
    const result = await $api.delete(`/volumes/article/${articleId}`)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

export const createReference = createAsyncThunk(
  'create reference',
  async ({ articleId, referenceData }) => {
    try {
      const result = await $api.post(`/volumes/article/${articleId}/reference`, referenceData)
      return result.data
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return console.error(e.message)
      }
    }
  }
)

export const getReferenceById = createAsyncThunk(
  'get article reference by id',
  async referenceId => {
    try {
      const result = await $api.get(`/volumes/reference/${referenceId}`)
      return result.data
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return console.error(e.message)
      }
    }
  }
)

export const updateReference = createAsyncThunk(
  'update reference',
  async ({ referenceId, referenceData }) => {
    try {
      const result = await $api.put(`/volumes/reference/${referenceId}`, referenceData)
      return result.data
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return console.error(e.message)
      }
    }
  }
)

export const deleteReference = createAsyncThunk('delete reference', async referenceId => {
  try {
    const result = await $api.delete(`/volumes/reference/${referenceId}`)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

const initialState = {
  data: undefined,
  isLoading: false,
  error: null,
  volume: undefined,
  volumeLoading: false,
  volumeError: undefined,
  issue: undefined,
  issueLoading: false,
  issueError: undefined,
  article: undefined,
  articleLoading: false,
  articleError: undefined,
  articleReference: undefined,
  articleReferenceLoading: false,
  articleReferenceError: undefined,
}

export const volumesSlice = createSlice({
  name: 'volumes',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getVolumes.pending, state => {
        state.isLoading = true
        state.data = undefined
        state.error = null
      })
      .addCase(getVolumes.fulfilled, (state, action) => {
        state.isLoading = false
        state.data = action.payload
        state.error = null
      })
      .addCase(getVolumes.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload
        state.error = action.error.message
      })

    builder.addCase(getVolumeById.pending, state => {
      state.volume = undefined
      state.volumeLoading = true
      state.volumeError = null
    })
    builder.addCase(getVolumeById.fulfilled, (state, action) => {
      state.volume = action.payload
      state.volumeLoading = false
      state.volumeError = null
    })
    builder.addCase(getVolumeById.rejected, (state, action) => {
      state.volume = null
      state.volumeLoading = false
      state.volumeError = action.error.message
    })

    builder.addCase(getIssueById.pending, state => {
      state.issue = null
      state.issueLoading = true
      state.issueError = null
    })
    builder.addCase(getIssueById.fulfilled, (state, action) => {
      state.issue = action.payload
      state.issueLoading = false
      state.issueError = null
    })
    builder.addCase(getIssueById.rejected, (state, action) => {
      state.issue = null
      state.issueLoading = false
      state.issueError = action.error.message
    })

    builder.addCase(getArticleById.pending, state => {
      state.article = undefined
      state.articleLoading = true
      state.articleError = null
    })
    builder.addCase(getArticleById.fulfilled, (state, action) => {
      state.article = action.payload
      state.articleLoading = false
      state.articleError = null
    })
    builder.addCase(getArticleById.rejected, (state, action) => {
      state.article = null
      state.articleLoading = false
      state.articleError = action.error.message
    })

    builder.addCase(getReferenceById.pending, state => {
      state.articleReference = undefined
      state.articleReferenceLoading = true
      state.articleReferenceError = null
    })
    builder.addCase(getReferenceById.fulfilled, (state, action) => {
      state.articleReference = action.payload
      state.articleReferenceLoading = false
      state.articleReferenceError = null
    })
    builder.addCase(getReferenceById.rejected, (state, action) => {
      state.articleReference = null
      state.articleReferenceLoading = false
      state.articleReferenceError = action.error.message
    })
  },
})

export const { actions: volumesActions } = volumesSlice
export const { reducer: volumesReducer } = volumesSlice
